/*
 * @poppinss/prompts
 *
 * (c) Poppinss
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { createError } from '@poppinss/utils'

export const E_PROMPT_CANCELLED = createError('Prompt cancelled', 'E_PROMPT_CANCELLED', 500)
